'use client';

import { useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { useCommonData } from '@udemy-v2/common-data';
import { useI18n } from '@udemy-v2/i18n';
import { Toaster, ToasterStore, type AlertBannerProps } from '@udemy-v2/react-notice-components';
import { sendCourseInvitationRequest } from '@/app/lib/course-invite/course-invite';
import { CourseLimitedAccess } from './course-limited-access.react-component';
interface InviteOnlyCourseProps {
  /** Course id forwarded to the monolith `send-course-invitation-request` endpoint. */
  courseId?: string;
  onRequestInvite?: () => void;
}
export function InviteOnlyCourse({
  courseId,
  onRequestInvite
}: InviteOnlyCourseProps) {
  const {
    gettext
  } = useI18n();
  const commonData = useCommonData();
  const searchParams = useSearchParams();
  const [pending, setPending] = useState(false);
  const [completed, setCompleted] = useState(false);
  const isLoggedIn = !!commonData?.user;
  const successAlertBanner = {
    udStyle: 'success',
    title: gettext('Your invitation request was sent successfully.'),
    showCta: false,
    actionButtonProps: false
  } as AlertBannerProps;
  const loggedOutBanner = {
    udStyle: 'error',
    title: gettext('You must be logged in to request an invitation.'),
    showCta: false,
    actionButtonProps: false
  } as AlertBannerProps;
  async function handleRequestInvite() {
    onRequestInvite?.();
    if (!isLoggedIn) {
      ToasterStore.addAlertBannerToast(loggedOutBanner);
      return;
    }
    if (!courseId || pending) {
      return;
    }
    setPending(true);
    try {
      await sendCourseInvitationRequest({
        courseId,
        searchParams: searchParams as unknown as URLSearchParams | null
      });
      setCompleted(true);
      ToasterStore.addAlertBannerToast(successAlertBanner);
    } catch (error) {
      console.error('Failed to send course invitation request', error);
    } finally {
      setPending(false);
    }
  }
  return <>
            <CourseLimitedAccess buttonLabel={gettext('Request invitation')} onButtonClick={handleRequestInvite} buttonDisabled={pending || completed} />
            <Toaster />
        </>;
}